import { render, staticRenderFns } from "./CollapseCard.vue?vue&type=template&id=468df374&scoped=true&"
import script from "./CollapseCard.vue?vue&type=script&lang=js&"
export * from "./CollapseCard.vue?vue&type=script&lang=js&"
import style0 from "./CollapseCard.vue?vue&type=style&index=0&id=468df374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468df374",
  null
  
)

export default component.exports